import React from 'react'
import constant from '../../utils/CommonConstants'
import {
  Table,
  TableBody,
  TableRow,
  TableHeader,
  TableHeaderColumn,
  TableRowColumn
} from 'material-ui/Table'
import { RaisedButton } from 'material-ui'

const DynamicTable = ({ data, columns }) => {
  const renderCellContent = (row, column) => {
    if (column.type === 'button') {
      return (
        <RaisedButton
          label={column.label}
          primary
          onClick={() => column.clickAction(row)}
        />
      )
    }
    if (column.type === 'Date') {
      return constant.epochToDate(row.paymentReceivedDate)
    }
    return row[column.key]
  }

  const renderTableHeader = () => (
    <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
      <TableRow>
        {columns.map(column => (
          <TableHeaderColumn key={column.key}>{column.label}</TableHeaderColumn>
        ))}
      </TableRow>
    </TableHeader>
  )

  const renderTableBody = () => (
    <TableBody displayRowCheckbox={false}>
      {data.map((row, rowIndex) => (
        <TableRow key={rowIndex}>
          {columns.map(column => (
            <TableRowColumn
              key={column.key}
              style={{ color: column.textColor }}
            >
              {renderCellContent(row, column)}
            </TableRowColumn>
          ))}
        </TableRow>
      ))}
    </TableBody>
  )

  if (!data || data.length === 0) {
    return <h5>Nothing to show here</h5>
  }

  return (
    <Table>
      {renderTableHeader()}
      {renderTableBody()}
    </Table>
  )
}

export default DynamicTable



/** WEBPACK FOOTER **
 ** ./src/components/CommonEntityTable/EntityTable.js
 **/